"use strict";

var _regeneratorRuntime = require("F:\\TypeScript\\zymplectic\\node_modules\\@babel\\runtime/regenerator");

var _possibleConstructorReturn = require("F:\\TypeScript\\zymplectic\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("F:\\TypeScript\\zymplectic\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("F:\\TypeScript\\zymplectic\\node_modules\\@babel\\runtime/helpers/inherits");

var _classCallCheck = require("F:\\TypeScript\\zymplectic\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\TypeScript\\zymplectic\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var operations_1 = require("./operations");

function areContextsEqual(a, b) {
  if (a === null) {
    return false;
  }

  for (var name in a.variableValues) {
    if (a.variableValues[name] !== b.variableValues[name]) {
      return false;
    }
  }

  for (var _name in b.variableValues) {
    if (a.variableValues[_name] !== b.variableValues[_name]) {
      return false;
    }
  }

  return true;
}

var Expression =
/*#__PURE__*/
function () {
  function Expression() {
    _classCallCheck(this, Expression);

    this.cachedResult = {
      context: null,
      result: 0
    };
  }

  _createClass(Expression, [{
    key: "evaluate",
    value: function evaluate(context) {
      if (context.noCache) {
        return this.evaluateImpl(context);
      }

      if (!areContextsEqual(this.cachedResult.context, context)) {
        this.cachedResult.context = Object.assign(Object.assign({}, context), {
          variableValues: Object.assign({}, context.variableValues)
        });
        this.cachedResult.result = this.evaluateImpl(context);
      }

      return this.cachedResult.result;
    }
  }]);

  return Expression;
}();

exports.Expression = Expression;

var Constant =
/*#__PURE__*/
function (_Expression) {
  _inherits(Constant, _Expression);

  function Constant(value) {
    var _this;

    _classCallCheck(this, Constant);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Constant).call(this));
    _this.value = value;

    _this.evaluateToString = function () {
      return _this.value.toString();
    };

    _this.evaluateImpl = function (context) {
      return _this.value;
    };

    return _this;
  }

  _createClass(Constant, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, getDependencies);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return function (gradOutput) {
                return new Constant(0);
              };

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Constant;
}(Expression);

exports.Constant = Constant;

var Variable =
/*#__PURE__*/
function (_Expression2) {
  _inherits(Variable, _Expression2);

  function Variable(name) {
    var _this2;

    _classCallCheck(this, Variable);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Variable).call(this));
    _this2.name = name;

    _this2.evaluateToString = function () {
      return _this2.name.toString();
    };

    _this2.evaluateImpl = function (context) {
      var value = context.variableValues[_this2.name];

      if (value === undefined) {
        throw new Error("No value specified for variable ".concat(_this2.name));
      }

      return value;
    };

    return _this2;
  }

  _createClass(Variable, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }
      }, getDependencies);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
            case "end":
              return _context4.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Variable;
}(Expression);

exports.Variable = Variable;

var Add =
/*#__PURE__*/
function (_Expression3) {
  _inherits(Add, _Expression3);

  function Add(a, b) {
    var _this3;

    _classCallCheck(this, Add);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Add).call(this));
    _this3.a = a;
    _this3.b = b;

    _this3.evaluateToString = function () {
      return "(".concat(_this3.a.evaluateToString(), " + ").concat(_this3.b.evaluateToString(), ")");
    };

    _this3.evaluateImpl = function (context) {
      return _this3.a.evaluate(context) + _this3.b.evaluate(context);
    };

    return _this3;
  }

  _createClass(Add, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.a;

            case 2:
              _context5.next = 4;
              return this.b;

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return function (dOutput) {
                return dOutput;
              };

            case 2:
              _context6.next = 4;
              return function (dOutput) {
                return dOutput;
              };

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Add;
}(Expression);

exports.Add = Add;

var Subtract =
/*#__PURE__*/
function (_Expression4) {
  _inherits(Subtract, _Expression4);

  function Subtract(a, b) {
    var _this4;

    _classCallCheck(this, Subtract);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Subtract).call(this));
    _this4.a = a;
    _this4.b = b;

    _this4.evaluateToString = function () {
      return "(".concat(_this4.a.evaluateToString(), " - ").concat(_this4.b.evaluateToString(), ")");
    };

    _this4.evaluateImpl = function (context) {
      return _this4.a.evaluate(context) - _this4.b.evaluate(context);
    };

    return _this4;
  }

  _createClass(Subtract, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.a;

            case 2:
              _context7.next = 4;
              return this.b;

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return function (dOutput) {
                return dOutput;
              };

            case 2:
              _context8.next = 4;
              return function (dOutput) {
                return new Negate(dOutput);
              };

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Subtract;
}(Expression);

exports.Subtract = Subtract;

var Multiply =
/*#__PURE__*/
function (_Expression5) {
  _inherits(Multiply, _Expression5);

  function Multiply(a, b) {
    var _this5;

    _classCallCheck(this, Multiply);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(Multiply).call(this));
    _this5.a = a;
    _this5.b = b;

    _this5.evaluateToString = function () {
      return "(".concat(_this5.a.evaluateToString(), " * ").concat(_this5.b.evaluateToString(), ")");
    };

    _this5.evaluateImpl = function (context) {
      return _this5.a.evaluate(context) * _this5.b.evaluate(context);
    };

    return _this5;
  }

  _createClass(Multiply, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.a;

            case 2:
              _context9.next = 4;
              return this.b;

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this6 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return function (dOutput) {
                return new Multiply(_this6.b, dOutput);
              };

            case 2:
              _context10.next = 4;
              return function (dOutput) {
                return new Multiply(_this6.a, dOutput);
              };

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Multiply;
}(Expression);

exports.Multiply = Multiply;

var Divide =
/*#__PURE__*/
function (_Expression6) {
  _inherits(Divide, _Expression6);

  function Divide(a, b) {
    var _this7;

    _classCallCheck(this, Divide);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(Divide).call(this));
    _this7.a = a;
    _this7.b = b;

    _this7.evaluateToString = function () {
      return "(".concat(_this7.a.evaluateToString(), " / ").concat(_this7.b.evaluateToString(), ")");
    };

    _this7.evaluateImpl = function (context) {
      return _this7.a.evaluate(context) / _this7.b.evaluate(context);
    };

    return _this7;
  }

  _createClass(Divide, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.a;

            case 2:
              _context11.next = 4;
              return this.b;

            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this8 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return function (dOutput) {
                return new Divide(dOutput, _this8.b);
              };

            case 2:
              _context12.next = 4;
              return function (dOutput) {
                return new Multiply(new Divide(new Negate(_this8.a), new Power(_this8.b, new Constant(2))), dOutput);
              };

            case 4:
            case "end":
              return _context12.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Divide;
}(Expression);

exports.Divide = Divide;

var Sin =
/*#__PURE__*/
function (_Expression7) {
  _inherits(Sin, _Expression7);

  function Sin(a) {
    var _this9;

    _classCallCheck(this, Sin);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(Sin).call(this));
    _this9.a = a;

    _this9.evaluateToString = function () {
      return "sin(".concat(_this9.a.evaluateToString(), ")");
    };

    _this9.evaluateImpl = function (context) {
      return Math.sin(_this9.a.evaluate(context));
    };

    return _this9;
  }

  _createClass(Sin, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this10 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return function (dOutput) {
                return new Multiply(new Cos(_this10.a), dOutput);
              };

            case 2:
            case "end":
              return _context14.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Sin;
}(Expression);

exports.Sin = Sin;

var Cos =
/*#__PURE__*/
function (_Expression8) {
  _inherits(Cos, _Expression8);

  function Cos(a) {
    var _this11;

    _classCallCheck(this, Cos);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Cos).call(this));
    _this11.a = a;

    _this11.evaluateToString = function () {
      return "cos(".concat(_this11.a.evaluateToString(), ")");
    };

    _this11.evaluateImpl = function (context) {
      return Math.cos(_this11.a.evaluate(context));
    };

    return _this11;
  }

  _createClass(Cos, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context15.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this12 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return function (dOutput) {
                return new Multiply(new Negate(new Sin(_this12.a)), dOutput);
              };

            case 2:
            case "end":
              return _context16.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Cos;
}(Expression);

exports.Cos = Cos;

var Tan =
/*#__PURE__*/
function (_Expression9) {
  _inherits(Tan, _Expression9);

  function Tan(a) {
    var _this13;

    _classCallCheck(this, Tan);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(Tan).call(this));
    _this13.a = a;

    _this13.evaluateToString = function () {
      return "tan(".concat(_this13.a.evaluateToString(), ")");
    };

    _this13.evaluateImpl = function (context) {
      return Math.tan(_this13.a.evaluate(context));
    };

    return _this13;
  }

  _createClass(Tan, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context17.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this14 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return function (dOutput) {
                return new Divide(dOutput, new Power(new Cos(_this14.a), new Constant(2)));
              };

            case 2:
            case "end":
              return _context18.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Tan;
}(Expression);

exports.Tan = Tan;

var Log =
/*#__PURE__*/
function (_Expression10) {
  _inherits(Log, _Expression10);

  function Log(a) {
    var _this15;

    _classCallCheck(this, Log);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(Log).call(this));
    _this15.a = a;

    _this15.evaluateToString = function () {
      return "log(".concat(_this15.a.evaluateToString(), ")");
    };

    _this15.evaluateImpl = function (context) {
      return Math.log(_this15.a.evaluate(context));
    };

    return _this15;
  }

  _createClass(Log, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context19.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this16 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return function (dOutput) {
                return new Divide(dOutput, _this16.a);
              };

            case 2:
            case "end":
              return _context20.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Log;
}(Expression);

exports.Log = Log;

var Power =
/*#__PURE__*/
function (_Expression11) {
  _inherits(Power, _Expression11);

  function Power(a, b) {
    var _this17;

    _classCallCheck(this, Power);

    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(Power).call(this));
    _this17.a = a;
    _this17.b = b;

    _this17.evaluateToString = function () {
      return "(".concat(_this17.a.evaluateToString(), " ^ ").concat(_this17.b.evaluateToString(), ")");
    };

    _this17.evaluateImpl = function (context) {
      return Math.pow(_this17.a.evaluate(context), _this17.b.evaluate(context));
    };

    return _this17;
  }

  _createClass(Power, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.a;

            case 2:
              _context21.next = 4;
              return this.b;

            case 4:
            case "end":
              return _context21.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this18 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return function (dOutput) {
                return new Multiply(new Multiply(_this18.b, new Power(_this18.a, new Subtract(_this18.b, new Constant(1)))), dOutput);
              };

            case 2:
              _context22.next = 4;
              return function (dOutput) {
                return new Multiply(new Multiply(new Power(_this18.a, _this18.b), new Log(_this18.a)), dOutput);
              };

            case 4:
            case "end":
              return _context22.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Power;
}(Expression);

exports.Power = Power;

var Negate =
/*#__PURE__*/
function (_Expression12) {
  _inherits(Negate, _Expression12);

  function Negate(a) {
    var _this19;

    _classCallCheck(this, Negate);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(Negate).call(this));
    _this19.a = a;

    _this19.evaluateToString = function () {
      return "(-".concat(_this19.a.evaluateToString(), ")");
    };

    _this19.evaluateImpl = function (context) {
      return -_this19.a.evaluate(context);
    };

    return _this19;
  }

  _createClass(Negate, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context23.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return function (dOutput) {
                return new Negate(dOutput);
              };

            case 2:
            case "end":
              return _context24.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Negate;
}(Expression);

exports.Negate = Negate;

var Exp =
/*#__PURE__*/
function (_Expression13) {
  _inherits(Exp, _Expression13);

  function Exp(a) {
    var _this20;

    _classCallCheck(this, Exp);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(Exp).call(this));
    _this20.a = a;

    _this20.evaluateToString = function () {
      return "exp(".concat(_this20.a.evaluateToString(), ")");
    };

    _this20.evaluateImpl = function (context) {
      return Math.exp(_this20.a.evaluate(context));
    };

    return _this20;
  }

  _createClass(Exp, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context25.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this21 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return function (dOutput) {
                return new Multiply(_this21, dOutput);
              };

            case 2:
            case "end":
              return _context26.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Exp;
}(Expression);

exports.Exp = Exp;

var Sign =
/*#__PURE__*/
function (_Expression14) {
  _inherits(Sign, _Expression14);

  function Sign(a) {
    var _this22;

    _classCallCheck(this, Sign);

    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(Sign).call(this));
    _this22.a = a;

    _this22.evaluateToString = function () {
      return "sign(".concat(_this22.a.evaluateToString(), ")");
    };

    _this22.evaluateImpl = function (context) {
      return Math.sign(_this22.a.evaluate(context));
    };

    return _this22;
  }

  _createClass(Sign, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context27.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return function (dOutput) {
                return new Constant(0);
              };

            case 2:
            case "end":
              return _context28.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Sign;
}(Expression);

exports.Sign = Sign;

var Abs =
/*#__PURE__*/
function (_Expression15) {
  _inherits(Abs, _Expression15);

  function Abs(a) {
    var _this23;

    _classCallCheck(this, Abs);

    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(Abs).call(this));
    _this23.a = a;

    _this23.evaluateToString = function () {
      return "abs(".concat(_this23.a.evaluateToString(), ")");
    };

    _this23.evaluateImpl = function (context) {
      return Math.abs(_this23.a.evaluate(context));
    };

    return _this23;
  }

  _createClass(Abs, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      return _regeneratorRuntime.wrap(function getDependencies$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.next = 2;
              return this.a;

            case 2:
            case "end":
              return _context29.stop();
          }
        }
      }, getDependencies, this);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _this24 = this;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return function (dOutput) {
                return new Multiply(new Sign(_this24.a), dOutput);
              };

            case 2:
            case "end":
              return _context30.stop();
          }
        }
      }, getDependencyDerivatives);
    })
  }]);

  return Abs;
}(Expression);

exports.Abs = Abs;

var Derivative =
/*#__PURE__*/
function (_Expression16) {
  _inherits(Derivative, _Expression16);

  function Derivative(a, b) {
    var _this25;

    _classCallCheck(this, Derivative);

    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(Derivative).call(this));
    _this25.a = a;
    _this25.b = b;

    _this25.evaluateToString = function () {
      return _this25.derivativeExpr.evaluateToString();
    };

    _this25.evaluateImpl = function (context) {
      return _this25.derivativeExpr.evaluate(context);
    };

    _this25.derivativeExpr = operations_1.getDerivativeForExpression(a, operations_1.getAllDerivatives(b, new Constant(1)));
    return _this25;
  }

  _createClass(Derivative, [{
    key: "getDependencies",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencies() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, dependency;

      return _regeneratorRuntime.wrap(function getDependencies$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context31.prev = 3;
              _iterator = this.derivativeExpr.getDependencies()[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context31.next = 12;
                break;
              }

              dependency = _step.value;
              _context31.next = 9;
              return dependency;

            case 9:
              _iteratorNormalCompletion = true;
              _context31.next = 5;
              break;

            case 12:
              _context31.next = 18;
              break;

            case 14:
              _context31.prev = 14;
              _context31.t0 = _context31["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context31.t0;

            case 18:
              _context31.prev = 18;
              _context31.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 21:
              _context31.prev = 21;

              if (!_didIteratorError) {
                _context31.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context31.finish(21);

            case 25:
              return _context31.finish(18);

            case 26:
            case "end":
              return _context31.stop();
          }
        }
      }, getDependencies, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
  }, {
    key: "getDependencyDerivatives",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getDependencyDerivatives() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, dependencyDerivative;

      return _regeneratorRuntime.wrap(function getDependencyDerivatives$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context32.prev = 3;
              _iterator2 = this.derivativeExpr.getDependencyDerivatives()[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context32.next = 12;
                break;
              }

              dependencyDerivative = _step2.value;
              _context32.next = 9;
              return dependencyDerivative;

            case 9:
              _iteratorNormalCompletion2 = true;
              _context32.next = 5;
              break;

            case 12:
              _context32.next = 18;
              break;

            case 14:
              _context32.prev = 14;
              _context32.t0 = _context32["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context32.t0;

            case 18:
              _context32.prev = 18;
              _context32.prev = 19;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 21:
              _context32.prev = 21;

              if (!_didIteratorError2) {
                _context32.next = 24;
                break;
              }

              throw _iteratorError2;

            case 24:
              return _context32.finish(21);

            case 25:
              return _context32.finish(18);

            case 26:
            case "end":
              return _context32.stop();
          }
        }
      }, getDependencyDerivatives, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
  }]);

  return Derivative;
}(Expression);

exports.Derivative = Derivative;